// extracted by mini-css-extract-plugin
export default {"carousel":"index-module__carousel___i2Roi","buttons":"index-module__buttons___tLOeu","track":"index-module__track___mHR1n"};